const tournamentPageId = "[data-tournament-view]";
const christmasTournamentPageId = "[data-christmas-tournament-view]";
const landingRegistrationPageId = "[data-landing-registration-view]";
const landingPageWithoutHeader = "data-landing-view-without-header";
const landingPageWithoutFooter = "data-landing-view-without-footer";
const landingPageWithoutMobileBottomMenu = "data-landing-view-without-mobile-bottom-menu";
const landingPageRegistrationFormPattern = "data-ladning-registration-form";
const landingPageWithoutPromoSnackbar = "data-landing-view-without-promo-snackbar";
const sportVIPID = "[data-sport-vip-view]";
const casinoVIPID = "[data-casino-vip-view]";
const slotRacePageStringPattern = /data-tournament-view=|data-slot-race-tournament-view/;
const christmasTournamentStringPattern = "data-christmas-tournament-view";
const sportVIPStringPattern = "data-sport-vip-view";
const casinoVIPStringPattern = "data-casino-vip-view";
const landingRegistrationPagePattern = "data-landing-registration-view";
export {
  casinoVIPID,
  casinoVIPStringPattern,
  christmasTournamentPageId,
  christmasTournamentStringPattern,
  landingPageRegistrationFormPattern,
  landingPageWithoutFooter,
  landingPageWithoutHeader,
  landingPageWithoutMobileBottomMenu,
  landingPageWithoutPromoSnackbar,
  landingRegistrationPageId,
  landingRegistrationPagePattern,
  slotRacePageStringPattern,
  sportVIPID,
  sportVIPStringPattern,
  tournamentPageId
};
